import { Component, OnInit, OnChanges, Output, EventEmitter, Input, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SearchListComponent } from './search/search.component';
import { TableComponent } from './table/table.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "app-list-view",
  templateUrl: "./list-view.component.html",
  styleUrls: ["./list-view.component.scss"],
})
export class ListViewComponent implements OnInit, OnChanges {
  @Output() mapView = new EventEmitter<boolean>();
  @Output() switchListLang = new EventEmitter();
  @Output() sendFilter = new EventEmitter<boolean>();
  @Output() kw = new EventEmitter();
  @Input() data: any[];
  @Input() langMap: string;
  //@ViewChild(SearchListComponent) filterList: SearchListComponent;
  @ViewChild(SearchListComponent, { static: true })
  filterList: SearchListComponent;

  //@ViewChild(TableComponent) filterArea: TableComponent;
  @ViewChild(TableComponent, { static: true }) filterArea: TableComponent;

  areas = [];
  keyword = "";
  stateFilter = false;
  isFilter = false;
  lang = "";

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.areas = this.data;
  }

  ngOnChanges() {
    this.lang = this.langMap;
  }

  filterAreas(textFilter) {
    this.keyword = textFilter;
  }

  filterReceive(event) {
    this.filterArea.filterArray(event);
  }

  setKeyword(event) {
    this.kw.emit(event);
  }
}
